import { useEffect, useState } from 'react';
import { tierRank } from './auth';

const API = process.env.REACT_APP_API_URL || '';
let cachedMatrix = null;
let pendingMatrix = null;

export async function loadCapabilityMatrix() {
  if (cachedMatrix) return cachedMatrix;
  if (!pendingMatrix) {
    pendingMatrix = fetch(`${API}/api/product/capabilities`)
      .then(async response => {
        if (!response.ok) throw new Error(`capability matrix HTTP ${response.status}`);
        const matrix = await response.json();
        if (matrix.schema !== 'quant-product-capabilities-v1') {
          throw new Error('unsupported capability matrix');
        }
        cachedMatrix = matrix;
        return matrix;
      })
      .finally(() => { pendingMatrix = null; });
  }
  return pendingMatrix;
}

export function useCapabilityMatrix() {
  const [state, setState] = useState({ matrix: cachedMatrix, error: null });
  useEffect(() => {
    let active = true;
    loadCapabilityMatrix()
      .then(matrix => { if (active) setState({ matrix, error: null }); })
      .catch(error => { if (active) setState({ matrix: null, error }); });
    return () => { active = false; };
  }, []);
  return state;
}

export function capabilityDetails(matrix, capability) {
  if (!matrix || !capability) return null;
  return matrix.capabilities?.[capability] || null;
}

export function useCapabilityAccess(capability) {
  const state = useCapabilityMatrix();
  const spec = capabilityDetails(state.matrix, capability);
  const requiredRank = state.matrix?.tier_order?.indexOf(spec?.minimum_tier);
  return {
    ...state,
    ready: !!state.matrix,
    allowed: Number.isInteger(requiredRank) && requiredRank >= 0
      ? tierRank() >= requiredRank
      : false,
  };
}
